import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../config/query.config';
import { baseApi } from './baseApi.service';

const authenticationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    resendInviteSignInLink: builder.mutation<void, { token: string }>({
      query: ({ token }) => ({
        url: '/auth/invite/resend-signin-link',
        method: 'POST',
        body: { token },
      }),
    }),
    acceptInvite: builder.mutation<void, { token: string; firstName: string; lastName: string }>({
      query: ({ token, firstName, lastName }) => ({
        url: '/auth/bootstrap',
        method: 'POST',
        body: {
          token,
          firstName,
          lastName,
        },
      }),
    }),
  }),
});

const sessionApi = createApi({
  reducerPath: 'sessionApi',
  baseQuery,
  endpoints: (builder) => ({
    session: builder.mutation<void, void>({
      query: () => ({
        url: '/auth/session',
        method: 'POST',
      }),
    }),
  }),
});

export const { useResendInviteSignInLinkMutation, useAcceptInviteMutation } = authenticationApi;
export const { useSessionMutation } = sessionApi;
export { sessionApi };
